import {cursosDeAlumno, pildoraDeCurso, estadoDeCurso}
	from "./../../utils/cursoCorto"
import {paginaInicial}
	from "./../../utils/paginaRecordada"
import {
	useState,
	useRef,
	useReducer,
	useEffect,
	Suspense,
	lazy
} from "react"

import {
	useDispatch,
	useSelector
} from "react-redux"

import { useNavigate, useSearchParams } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"
import Multiselect from "multiselect-react-dropdown"
import { Tooltip, Popover } from "react-bootstrap"
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Hashids from "hashids"
import _ from "lodash"
import { sprintf } from "sprintf-js"

import {
	RootState,
	setCurrentUserCampus,
	setCurrentUserCampusId,
	enableIdleLockSwitch,
	disableIdleLockSwitch,
	displayNotice,
	dismissNotice,
	AppDispatch
} from "./../../globals"

import {
	UIState,
	pageGrouping,
	validateField,
	hashCode,
	getAccessPermissions,
	isEmpty,
	operators,
	isNotEmpty,
	operatorList,
	getErrorMessage,
	nombrePropio
} from "./../../common"

import Constants,
{
	employeeStatus,
	ENROLLMENT_STATUS,
	studentStatus
} from "./../../constants"

import CustomIcon from "./../../components/customIcon"
import SectionContainer from "./../../components/sectionContainer"
import FiltroHorarios, { SeleccionHorarios, SIN_SELECCION } from "./../../components/filtroHorarios/filtroHorarios"
import StudentInfoModal from "./studentInfoModal"
import EnrollStudentModal from "./enrollStudentModal"
import IconoMatricular from "./../../components/iconoMatricular"
import {formatPhoneDisplay, prefixForCountryId} from "./../../components/phoneField"
import ListaTarjetas from "./../../components/listaTarjetas/listaTarjetas"
import {useEsTelefono} from "./../../utils/esTelefono"
import EmployeeInfoModal from "./employeeInfoModal"
import CatalogService from "./../../services/catalog.service"
import RolesService
	from "./../../services/roles.service"
import StudentsService from "./../../services/campus/students.service"
import HttpManager from "../../services/HttpManager";
import "./../../components/dropdown/style.css"
import "./../../components/input/style.css"
import { setStudentData } from "../../redux/reducers/accountStatementReducer"
import { setCurrentCampus, setCurrentCampusId } from "../../redux/reducers/sessionReducer"
import UpdateCampusInfo from "./updateCampusInfo/updateCampusInfo"
//"Ninguno" fuera: casi nadie llega sin haber cursado ni un grado, y era la
//opcion por defecto, asi que 13,859 alumnos quedaron marcados asi sin serlo.
//(Esteban, 2026-09-22)
const sinNinguno = (grados: any[]) => (grados || []).filter((g: any) => Number(g.id) !== 0)

const ModalComponent = lazy(() => import("../../components/modals/modal/modal"));

// Los botones de acción de cada fila comparten alto y centrado, para que los
// íconos queden alineados entre sí (Esteban, 2026-09-11).
const ESTILO_ACCION: any =
{
	color          : "var(--txt-color)",
	display        : "inline-flex",
	alignItems     : "center",
	justifyContent : "center",
	height         : "34px",
	width          : "34px",
	padding        : "0px"
}

type State = { isButtonDisabled: boolean }
const initialState: State = { isButtonDisabled: true }
type Action = {
	type: "setIsButtonDisabled",
	payload: boolean
}

const reducer = (state: State, action: Action): State => {
	switch (action.type) { case "setIsButtonDisabled": return { ...state, isButtonDisabled: action.payload } }
}

const Students = ()=>
{
	const ACADEMIC_DEGREES : number = 0
	const ENDING : number = 1

	const dispatch = useDispatch<AppDispatch>();
	const [state, trigger] = useReducer(reducer, initialState)
	const [academicDegrees, setAcademicDegrees] = useState<any>([])
	const [totalRecords, setTotalRecords] = useState<number>(0)
	const [initSetup, setInitSetup] = useState<number | null>(null)
	const [data, setData] = useState<any[]>([])
	const [readOnlyData, setReadOnlyData] = useState<any[]>([])
	const [employeeRoles, setEmployeeRoles] = useState<any[]>([])
	const [warningReport, listWarnings] = useState<any>({})
	const currentUser: any = useSelector((state: RootState) => state.userProfile.value)
	const idleLocked: boolean = useSelector((state: RootState) => state.idleLockSwitch.value)
	//Estas tablas tienen tantas columnas que ni en una tablet caben: las tarjetas
	//entran antes que en el resto de la app. (Esteban, 2026-09-16)
	const esTelefono : boolean = useEsTelefono(1024)
	const sessionToken: string | null = useSelector((state: RootState) => state.sessionToken.value)
	const themeToggle: boolean = useSelector((state: RootState) => state.themeToggle.value)
	const basicInfo: any = useSelector((state: RootState) => state.basicInfo.value)
	const currentUserCampus: any = useSelector((state: RootState) => state.currentUserCampus.value)
	const campusRef: any = useSelector((state: RootState) => state.campusRef.value)
	const currentCampus: any = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampus);
	const [userCampus, setUserCampus] = useState<number>(currentUserCampus)
	const studentStatuses: any = Object.values(basicInfo.studentStatusRef)
	const [sectionLoaded, setSectionLoaded] = useState<boolean>(false)
	const [moduleReady, setModuleReady] = useState<boolean>(false)
	const [clearSearchRequested, setClearSearchRequested] = useState<boolean>(false)
	const [currentTab, setCurrentTab] = useState<string | null>("mainInfo")
	const [UIStatus, setUIStatus] = useState<number>(UIState.NORMAL)
	const [newStudent, setNewStudent] = useState<any>({})
	const [extendedFilterShown, setExtendedFilterShown] = useState<boolean>(false)
	const [selectedStudent, setSelectedStudent] = useState<any>(null)
	const [selectedEmployee, setSelectedEmployee] = useState<any>(null)
	// Alumno al que se le va a matricular un horario desde la fila (Esteban, 2026-09-11).
	const [enrollingStudent, setEnrollingStudent] = useState<any>(null)
	// Fila cuyo menú de "Otras acciones" está abierto.
	const [menuAbierto, setMenuAbierto] = useState<any>(null)
	const [pagination, setPagination] = useState<any>(null)
	const [saveSuccess, setSaveSuccess] = useState<boolean>(false)
	const [saveError, setSaveError] = useState<any>(null)
	const [selectedRecords, setSelectedRecords] = useState<number>(0)
	const [selectableRecords, setSelectableRecords] = useState<number>(0)
	const [selectedRef, setSelectedRef] = useState<any>({})
	const [currentDate, setCurrentDate] = useState<any>(null)
	const [handleUpdateCampusModal, setHandleUpdateCampusModal] = useState<boolean>(false);
	const [saveLock, setSaveLock] = useState<boolean>(true);
	const [currentStudentUpdate, setCurrentStudentUpdate] = useState<any>(null);
	const [addNewCampusData, setAddNewCampusData] = useState<any>({});
	//Los teléfonos del país del plantel se muestran en formato local (Esteban, 2026-09-11).
	const prefijoDelPlantel : string = prefixForCountryId(campusRef?.[currentUserCampus]?.company?.country_id)
	const allowance : any = getAccessPermissions(currentUser)
	const employeeAllowance : any = getAccessPermissions(currentUser, "employees")
	//"Matricular" solo para quien puede crear matrículas: Supervisión de Ventas ve Estudiantes pero
	//matricula por medio de una solicitud (Esteban, 2026-09-24).
	const puedeMatricular : boolean = !!getAccessPermissions(currentUser, "enrollments").create
	//"Agregar a otro plantel" tiene su propio permiso: asesoras y supervisión/dirección de admisiones y ventas
	//lo hacen sin poder editar la ficha del alumno (Esteban, 2026-09-24).
	const puedeAgregarPlantel : boolean = !!getAccessPermissions(currentUser, "studentCampuses").create
	let   searchFormRef = useRef<HTMLFormElement>(null);
	const http = HttpManager.getInstance();

	const activeScheduleSearch = ["No", "Sí", "Mostrar todo"]
	const defaultSearch ={
		q: "",
		statusId: studentStatus.ACTIVE,
		tags: [],
		activeSchedule: 2,
		monthlyBalance: operatorList[0].code,
		productsBalance: operatorList[0].code,
		monthlyQuantity: 0,
		productsQuantity: 0,
		//Botones Curso / Periodo / Horario, como el Catálogo de Horarios (Esteban, 2026-09-24).
		...SIN_SELECCION
	}

	const [customSearch, setCustomSearch] = useState<any>(defaultSearch)
	const navigate = useNavigate()
	// Enlace directo al perfil de un alumno: /students?alumno=<id>&plantel=<id> (Esteban, 2026-09-11).
	const [searchParams, setSearchParams] = useSearchParams()
	const campuses: any[] = useSelector((state: RootState) => state.rootReducer.catalog.campuses)
	const enlaceAtendido = useRef<string | null>(null)

	const showUpdateCampusModal = async (params: any) => {
		const campuses = await getCampusesByStudent(params.id)
		setCurrentStudentUpdate({
			student:params,
			campuses:campuses
		});
		setHandleUpdateCampusModal(true);
	}

	const closeUpdateCampusModal = () => {
		setAddNewCampusData({});
		setCurrentStudentUpdate(null);
		setHandleUpdateCampusModal(false);
	}

	const saveUpdateCampusModal = async () => {
		let response = await setAddToCampuses();
		if (response) {
			onSucces(`${addNewCampusData.student.first_name} fue agregado/a al plantel ( ${addNewCampusData.campus.label} ).`)
			setSaveLock(true);
			setCurrentStudentUpdate({
				student:currentStudentUpdate.student,
				campuses : response
			});
		}
	}

	const getCampusesByStudent = async (studentId:number) => {
        try {
            let response = await http.studentService.getCampusesByStudent(
				studentId
            );
            return response.data;
        } catch (error) {
            console.log(error);
            onError(getErrorMessage(error));
        }
    }

	const setAddToCampuses = async () => {
        try {
            let response = await http.studentService.addToOtherCampus(
               campusRef[currentUserCampus].id,
               addNewCampusData.campus.id,
               addNewCampusData.student.id
            );
            return response.data;
        } catch (error) {
            console.log(error);
            onError(getErrorMessage(error));
        }
    }

	const onError = (message: string) => {
        dispatch(displayNotice({
            cornerClose: false,
            message: message,
            heading:
			<h3 style={{
                color: "var(--wa-rojo-error)",
                display: "inline-block"}}>
                Error
            </h3>
        }));
    }

	const onSucces = (message: string) => {
        dispatch(displayNotice({
            cornerClose: false,
            message: message,
            heading:
			<h3 style={{
                color: "var(--wa-verde)",
                display: "inline-block" }}>
                Listo
            </h3>
        }));
    }

	const navigateTo = (params: any) => {
		const studentData = {
			id: params.id,
			email: params.email,
			userId: params.student.user_id,
			firstName: params.first_name,
			lastName: params.last_name,
			identityCode: params.student.identity_code,
			identificationCode: params.identification_code
		}
		dispatch(setStudentData(studentData));
		navigate("/statement", { state: params })
	}

	const showPrompt = (recordData: any) => {
		let refIndex: string
		let sessionIndex: any
		let formattedData: any
		let agenda: any = {}
		const hashIds: any = new Hashids()

		let student = {
			...recordData, imagePreview: recordData.image,
			enrollments: recordData.enrollments.map
				(
					(enrollment: any) => {
						refIndex = "S_" + enrollment.schedule.id
						sessionIndex = {}

						enrollment.schedule.sessions.map
							(
								(session: any) => {
									let currentHours = session.start_hours

									sessionIndex["S_" + session.week_day] = session

									while (currentHours < session.end_hours) {
										agenda[sprintf("DH%d%03d", session.week_day, currentHours)] = refIndex

										currentHours += 5
									}
								}
							)

						formattedData =
						{
							...enrollment.schedule, refIndex: refIndex,
							sessionRef: sessionIndex,
							//RGB code generation based on hashing the distinct parenting ids (schedule, level and course)------
							color: sprintf
								(
									"#%02X%02X%02X",
									(hashCode(hashIds.encode(enrollment.schedule.id)) & 255),
									(hashCode(enrollment.schedule.level.name) & 255),
									(hashCode(enrollment.schedule.level.course.name) & 255)
								)
						}

						return formattedData
					}
				),
			nonActiveEnrollments: recordData?.nonActiveEnrollments?.map
				(
					(enrollment: any) => {
						refIndex = "S_" + enrollment.schedule.id
						sessionIndex = {}

						enrollment.schedule.sessions.map
							(
								(session: any) => {
									let currentHours = session.start_hours

									sessionIndex["S_" + session.week_day] = session

									while (currentHours < session.end_hours) {
										agenda[sprintf("DH%d%03d", session.week_day, currentHours)] = refIndex

										currentHours += 5
									}
								}
							)

						formattedData =
						{
							...enrollment.schedule, refIndex: refIndex,
							sessionRef: sessionIndex,
							//RGB code generation based on hashing the distinct parenting ids (schedule, level and course)------
							color: sprintf
								(
									"#%02X%02X%02X",
									(hashCode(hashIds.encode(enrollment.schedule.id)) & 255),
									(hashCode(enrollment.schedule.level.name) & 255),
									(hashCode(enrollment.schedule.level.course.name) & 255)
								)
						}

						return formattedData
					}
				)
		}

		setUIStatus(UIState.NORMAL)
		setSaveError(null)
		setCurrentTab("mainInfo")
		setSelectedStudent({ ...student, city: student.city_id == null ? null : { ...student.city, label: student.city.name } })
	}

	const procedureComplaint = (message: string) => {
		dispatch
			(
				displayNotice
					({
						cornerClose: false,
						message: message,
						heading: <h3 style={{ color: "var(--wa-rojo-error)", display: "inline-block" }}>
							Error
						</h3>
					})
			)
	}

	const handleSearchChange = (e: any) => {
		if (e && e.target) {
			setCustomSearch({ ...customSearch, [e.target.name]: e.target.value })
		}
	}
	//Enlace directo al perfil de un alumno (Esteban, 2026-09-11)------------------------------------------------------------
	//La URL lleva alumno y plantel, así el enlace abre el mismo perfil para quien lo reciba.
	const enlaceDePerfil = (record: any) =>
		window.location.origin + "/students?alumno=" + record.id + "&plantel=" + campusRef[currentUserCampus].id

	const fijarEnlace = (record: any) => {
		const parametros = new URLSearchParams(searchParams)

		parametros.set("alumno", String(record.id))
		parametros.set("plantel", String(campusRef[currentUserCampus].id))
		setSearchParams(parametros, { replace: true })
	}

	const limpiarEnlace = () => {
		const parametros = new URLSearchParams(searchParams)

		enlaceAtendido.current = null

		if (parametros.has("alumno") || parametros.has("plantel")) {
			parametros.delete("alumno")
			parametros.delete("plantel")
			setSearchParams(parametros, { replace: true })
		}
	}

	const datosDePerfil = (record: any) =>
	({
		...record, phone: record.phone || "",
		observations: record.student.observations || "",
		id_clase_365: record.id_clase_365 || "",
		zipcode: record.zipcode || "",
		correlativo_clase_365: record.student.correlativo_clase_365 || "",
		identity_code: record.student.identity_code || "",
		academic_degree: record.student.academic_degree,
		academic_degree_id: record.student.academic_degree?.id,
		specific_academic_degree: record.student.specific_academic_degree || "",
		last_school_name: record.student.last_school_name || "",
		current_occupation: record.student.current_occupation || "",
		password: "",
		contacts: ((record.student.contacts && JSON.parse(record.student.contacts)) || [])
	})

	/*
		soloLectura viene de que lista salio el registro: la tabla de escritorio ya
		distinguia editables de no editables, pero las tarjetas de telefono abrian
		todo editable. (Esteban, 2026-09-16)
	*/
	const abrirPerfil = (record: any, soloLectura: boolean = false) => {
		enlaceAtendido.current = String(record.id)
		fijarEnlace(record)
		showPrompt({...datosDePerfil(record), bool_read_only: soloLectura ? 1 : 0})
	}

	const copiarEnlace = async (record: any) => {
		const enlace = enlaceDePerfil(record)

		try {
			await navigator.clipboard.writeText(enlace)
			dispatch
				(
					displayNotice
						({
							cornerClose: true,
							message: "Enlace copiado: " + enlace,
							heading: <h3 style={{ color: "var(--wa-verde)", display: "inline-block" }}>
								Listo
							</h3>
						})
				)
		}
		catch (error) {
			dispatch
				(
					displayNotice
						({
							cornerClose: true,
							message: enlace,
							heading: <h3 style={{ color: "var(--wa-tinta)", display: "inline-block" }}>
								Copie el enlace
							</h3>
						})
				)
		}
	}

	const cambiarPlantel = (campusId: number) => {
		const plantel = campuses?.find((campus: any) => campus.id === campusId)

		localStorage.setItem("currentCampus", "C_" + campusId)
		dispatch(setCurrentUserCampusId(campusId))
		dispatch(setCurrentUserCampus("C_" + campusId))
		dispatch(setCurrentCampusId(campusId))

		if (plantel != null) {
			dispatch(setCurrentCampus(plantel))
		}
	}

	//Trae al alumno del enlace por su id, con la misma consulta del listado, y abre su perfil.
	const abrirPerfilPorEnlace = async (alumnoId: number) => {
		const errorEnlace: string = "El alumno del enlace no pudo abrirse"

		dispatch(enableIdleLockSwitch())

		try {
			const result = await StudentsService.searchStudents
				(campusRef[currentUserCampus].id, { ...defaultSearch, statusId: -1, userId: alumnoId }, 1)
			const record: any = result.data?.data?.[0]

			if (record == null) {
				procedureComplaint("El alumno del enlace no está en este plantel o no está disponible")
				limpiarEnlace()
			}
			else {
				const fecha: any = record.birthday == null ? undefined : record.birthday.replaceAll("-", "/")
				//Mismo acomodo de ciudad que hace el listado, para que el perfil no reciba datos a medias.
				const ciudad: any = (record.state_id == null || record.city_id == null)
					? null
					: { ...record.city, label: record.city?.name }

				abrirPerfil
					({
						...record, birthday: fecha || "",
						city: ciudad,
						state_id: record.state_id == null ? "" : record.state_id,
						city_id: ciudad == null ? null : record.city_id,
						status_id: !record.bool_enabled ? 0 : record.student.status_id,
						birthdayValue: fecha == null ? "" : new Date(fecha + " 23:00:00"),
						enrollments: record.enrollments.filter((enrollment: any) => enrollment.status_id == ENROLLMENT_STATUS.ACTIVE),
						nonActiveEnrollments: record.enrollments.filter((enrollment: any) => enrollment.status_id != ENROLLMENT_STATUS.ACTIVE),
						cursos: cursosDeAlumno(record.enrollments, basicInfo.enrollmentStatusRef),
						refIndex: "S_" + record.id
					})
			}
		}
		catch (error) {
			console.log(error)
			procedureComplaint(errorEnlace)
			limpiarEnlace()
		}
		finally {
			dispatch(disableIdleLockSwitch())
		}
	}
	//FX---------------------------------------------------------------------------------------------------------------------
	useEffect
	(
		()=>
		{
			const onLoad = async ()=>
			{
				if(currentUserCampus == null)
				{
					procedureComplaint
					(
						"No hay planteles registrados o asignados al rol en uso por el usuario, " +
						"por lo que el acceso a este módulo permanecerá deshabilitado."
					)
				}
				else
				{
					dispatch(enableIdleLockSwitch())

					const degreeRetrievalError: string = "Los grados académicos no pudieron ser extraídos"

					try
					{
						const expand = true
						const result = await CatalogService.getAcademicDegrees(sessionToken)

						if(result.status == 200 || result.status == 204)
						{
							setAcademicDegrees(sinNinguno(result.data))
							setInitSetup(ACADEMIC_DEGREES)
						}
						else
						{
							procedureComplaint(degreeRetrievalError)
						}
					}
					catch(error)
					{
						procedureComplaint(degreeRetrievalError)
						dispatch(disableIdleLockSwitch())
					}
				}
			}

			if(sessionToken)
			{
				onLoad()
			}
		},
		[]
	)

	useEffect
	(
		()=>
		{
			const onLoad = async()=>
			{
				switch(initSetup)
				{
					case ACADEMIC_DEGREES:
						if(academicDegrees.length < 1)
						{
							dispatch(disableIdleLockSwitch())
							procedureComplaint
							(
								"No hay grados académicos en el registro, " +
									"por lo que el acceso a este módulo permanecerá deshabilitado"
							)
						}
						else
						{
							const roleRetrievalError : string = "No se pudo extraer el listado de roles para registrar alumnos como empleados"

							try
							{
								const result : any = await RolesService.searchRoles()

								if(result.status == 200 || result.status == 204)
								{
									setEmployeeRoles(result.data.map
									(
										(role : any)=>
										({
											...role, campuses : [],
											valid    : true
										})
									))
								}
								else
								{
									listWarnings({...warningReport, employeeRoles : roleRetrievalError})
								}

								setInitSetup(ENDING)
							}
							catch(error)
							{
								console.log(error)

								listWarnings({...warningReport, employeeRoles : roleRetrievalError})
								setInitSetup(ENDING)
							}
						}
					break
					case ENDING:
						if(employeeRoles.length < 1)
						{
							dispatch(disableIdleLockSwitch())
							listWarnings({...warningReport, employeeRoles : "No se encontraron roles registrados para registrar alumnos como empleados"})
						}

						setNewStudent
						({
							country_id               : basicInfo.countryRef["C_" + campusRef[currentUserCampus].company.country_id].id,
							nationality_id           : basicInfo.countryRef["C_" + campusRef[currentUserCampus].company.country_id].id,
							status_id                : studentStatus.ACTIVE,
							gender_id                : "",
							state_id                 : "",
							academic_degree_id       : "",
							identification_type_id   : basicInfo.countryRef["C_" + campusRef[currentUserCampus].company.country_id].preferred_identification_type_id,
							birthday                 : null,
							birthdayValue            : "",
							tags                     : [],
							contacts                 : [],
							enrollments              : [],
							identification_code      : "",
							identity_code            : "",
							last_school_name         : "",
							current_occupation       : "",
							city                     : "",
							address                  : "",
							zipcode                  : "",
							first_name               : "",
							last_name                : "",
							password                 : "",
							phone1                   : "",
							phone2                   : "",
							email                    : "",
							facebook                 : "",
							instagram                : "",
							observations             : ""
						})

						search()
					break
				}
			}
			onLoad()
		},
		[initSetup]
	)

	useEffect(() => setTotalRecords(data.length), [data])

	useEffect
	(
		() => {
			if (clearSearchRequested && _.isEqual(defaultSearch, customSearch)) {
				search()
			}
		},
		[customSearch, clearSearchRequested]
	)

	useEffect
	(
		() => {
			if (moduleReady) {
				if (basicInfo.countries.length < 1) {
					procedureComplaint("No hay países registrados, por lo que el acceso a este módulo permanecerá deshabilitado")
				}
				else {
					search()
				}
			}
		},
		[moduleReady]
	)

	//Alguien abrió /students?alumno=<id>&plantel=<id>: cambia de plantel si hace falta y abre el perfil.
	useEffect
	(
		() => {
			//Se espera a que el módulo tenga plantel y grados académicos, que es lo que necesita el perfil.
			if (currentUserCampus == null || campusRef?.[currentUserCampus] == null || academicDegrees.length < 1) {
				return
			}

			const alumnoEnlazado: string | null = searchParams.get("alumno")

			if (alumnoEnlazado == null || enlaceAtendido.current === alumnoEnlazado) {
				return
			}

			const plantelEnlazado: number = +(searchParams.get("plantel") || 0)

			if (plantelEnlazado > 0 && campusRef[currentUserCampus].id !== plantelEnlazado) {
				if (campusRef["C_" + plantelEnlazado] == null) {
					enlaceAtendido.current = alumnoEnlazado

					procedureComplaint("El enlace es de un plantel al que este usuario no tiene acceso")
				}
				else {
					cambiarPlantel(plantelEnlazado)
				}

				return
			}

			enlaceAtendido.current = alumnoEnlazado

			abrirPerfilPorEnlace(+alumnoEnlazado)
		},
		[academicDegrees, searchParams, currentUserCampus]
	)

	useEffect
	(
		() => {
			trigger
				({
					type: "setIsButtonDisabled",
					payload: (idleLocked || UIStatus == UIState.SUCCESS)
				})
		},
		[UIStatus, idleLocked]
	)

	useEffect
	(
		()=>
		{
			if((sectionLoaded && currentUserCampus) && (currentUserCampus != userCampus))
			{
				dispatch(enableIdleLockSwitch())
				setSectionLoaded(false)
				setNewStudent
				({
					...newStudent, country_id : campusRef[currentUserCampus].company.country_id,
					nationality_id : campusRef[currentUserCampus].company.country_id,
					identification_type_id : basicInfo.countryRef["C_" + campusRef[currentUserCampus].company.country_id].preferred_identification_type_id
				})
				localStorage.setItem("currentCampus", currentUserCampus)
				setUserCampus(currentUserCampus)
				clearSearch()
			}
		},
		[currentUserCampus, sectionLoaded]
	)
	//-----------------------------------------------------------------------------------------------------------------------
	//Cada cambio en los botones Curso / Periodo / Horario busca de una vez, desde la primera página.
	const [filtroHorarioCambio, setFiltroHorarioCambio] = useState<number>(0)
	const cambiarFiltroHorario = (seleccion: SeleccionHorarios) => {
		setCustomSearch((previo: any) => ({ ...previo, ...seleccion }))
		setFiltroHorarioCambio((n: number) => n + 1)
	}
	useEffect(() => { if (filtroHorarioCambio > 0) { search(1) } }, [filtroHorarioCambio])

	const clearSearch = () => {
		setCustomSearch(defaultSearch)
		setClearSearchRequested(true)
	}

	const search = async (page?: any) => {
		const searchError: string = "La búsqueda no pudo completarse"

		dispatch(enableIdleLockSwitch())

		if (extendedFilterShown) {
			setExtendedFilterShown(false)
		}

		try {
			const result = await StudentsService.searchStudents(campusRef[currentUserCampus].id, customSearch, paginaInicial(page))

			if (result.status == 200 || result.status == 204) {
				setPagination(pageGrouping(result.data.current_page, result.data.last_page))
				setCurrentDate(result.data.date)

				let normalData: any = []
				let disabledData: any = []
				let selectablesCount: number = 0
				let date: any
				let dataToPush: any
				let enrollments: any
				let nonActiveEnrollments: any

				result.data.data.map//records separation for read-only and normal ones.--------------------------------------
					(
						(record: any) => {
							date = record.birthday == null ? undefined : record.birthday.replaceAll("-", "/")

							enrollments = []
							nonActiveEnrollments = []

							record.enrollments.map
								(
									(enrollment: any) => {
										if (enrollment.status_id == ENROLLMENT_STATUS.ACTIVE) {
											enrollments.push(enrollment)
										}
										else {
											nonActiveEnrollments.push(enrollment)
										}
									}
								)

							dataToPush =
							{
								...record, birthday: date || "",
								status_id: !record.bool_enabled ? 0 : record.student.status_id,
								birthdayValue: date == null ? "" : new Date(date + " 23:00:00"),
								enrollments: enrollments,
								nonActiveEnrollments: nonActiveEnrollments,
								// Cursos del alumno, derivados de TODAS sus matrículas (utils/cursoCorto)
								cursos: cursosDeAlumno(record.enrollments, basicInfo.enrollmentStatusRef)
							}

							if (record.id == currentUser.id) {
								disabledData.push(dataToPush)
							}
							else {
								selectablesCount += +
									(
										(
											((+record.campuses[0].tuition_debt - +record.campuses[0].tuition_debt_settlement) == 0)
											&&
											((+record.campuses[0].article_debt - +record.campuses[0].article_debt_settlement) == 0)
										)
										&&
										(+record.campuses[0].positive_balance == 0 && !tieneHistorial(record))
									)

								if (dataToPush.state_id == null) {
									dataToPush =
									{
										...dataToPush, city: null,
										state_id: ""
									}
								}
								else {
									dataToPush.state_name = ""

									if (dataToPush.city_id == null) {
										dataToPush.city = null
									}
									else {
										dataToPush =
										{
											...dataToPush, city: { ...dataToPush.city, label: dataToPush.city.name },
											city_name: ""
										}
									}
								}

								//adding boolean data type to toggle checking used by batch operations (multiple updating/deletion)--------------------------
								normalData.push({ ...dataToPush, refIndex: "S_" + record.id })
							}
						}
					)

				setSelectedRef({})
				setReadOnlyData(disabledData)
				//adding boolean data type to toggle checking used by batch operations (multiple updating/deletion)----------
				setData(normalData)
				setSelectableRecords(selectablesCount)
				setSelectedRecords(0)
				setSectionLoaded(true)
			}
			else {
				procedureComplaint(searchError)
			}
		}
		catch (error) {
			console.log(error)
			procedureComplaint(searchError)
		}
		finally {
			dispatch(disableIdleLockSwitch())
			setClearSearchRequested(false)
		}
	}

	const toggleRecordSelection = (record: any) => {
		let selectedMap: any = { ...selectedRef }

		if (selectedMap[record.refIndex]) {
			delete selectedMap[record.refIndex]
		}
		else {
			selectedMap[record.refIndex] = record.id
		}

		setSelectedRef({ ...selectedMap })
		setSelectedRecords(Object.keys(selectedMap).length)
	}

	const toggleSelectAll = () => {
		const selected: boolean = selectedRecords < selectableRecords
		let selectedMap: any = !selected ? {} : { ...selectedRef }

		if (selected) {
			data.map
				(
					(record: any) => {
						if
							(
							(
								((+record.campuses[0].tuition_debt - +record.campuses[0].tuition_debt_settlement) == 0)
								&&
								((+record.campuses[0].article_debt - +record.campuses[0].article_debt_settlement) == 0)
							)
							&&
							(+record.campuses[0].positive_balance == 0 && !tieneHistorial(record))
						) {
							selectedMap[record.refIndex] = true
						}
					}
				)
		}

		setSelectedRef(selectedMap)
		setSelectedRecords(selectableRecords * (+selected))
	}

	const showSuccessMessage = () => {
        dispatch(displayNotice({
            cornerClose: false,
            message: "Información procesada con éxito",
            heading: <h3 style={{
                color: "var(--wa-verde)", display: "inline-block"
            }}>
                Listo
            </h3>
        }));
    }

	// Solo se puede borrar un alumno sin rastro en el plantel: ninguna matrícula (activa o no), ningún pago,
	// ninguna factura. Antes solo se miraban las matrículas activas y el saldo (Esteban, 2026-09-17).
	const tieneHistorial = (record: any): boolean =>
		(record.enrollments?.length ?? 0) > 0 || (record.nonActiveEnrollments?.length ?? 0) > 0 || +record.hasHistory > 0

	const esSuperAdmin: boolean = currentUser.currentRole == "superAdmin"
	const sePuedeBorrar = (record: any): boolean => !(
		((+record.campuses[0].tuition_debt - +record.campuses[0].tuition_debt_settlement) > 0) ||
		((+record.campuses[0].article_debt - +record.campuses[0].article_debt_settlement) > 0) ||
		record.campuses[0].positive_balance > 0 || tieneHistorial(record)
	)

	const confirmRemoval = (recordId?: any) => {
		dispatch
			(
				displayNotice
					({
						cornerClose: true,
						message: "¿Eliminar registro" + (!isNaN(recordId) || Object.keys(selectedRef).length < 2 ? "" : "s") + "?",
						heading: <h3 style={{ color: "var(--wa-tinta)", display: "inline-block" }}>
							Confirme
						</h3>,
						procedure: async () => {
							const recordIds: number[] = !isNaN(recordId) ? [recordId] : Object.values(selectedRef)
							const removalError: string = "El comando no pudo ser procesado"

							dispatch(enableIdleLockSwitch())
							dispatch(dismissNotice())

							try {
								const result = Object.keys(selectedRef).length < 2 
								? await http.studentService.deleteStudent(campusRef[currentUserCampus].id, recordId)
								: await StudentsService.removeStudents(campusRef[currentUserCampus].id, recordIds)

								if (result.status == 200 || result.status == 204) {
									showSuccessMessage();
									clearSearch()
								}
							}
							catch (error) {
								procedureComplaint(getErrorMessage(error))
							}
							finally {
								dispatch(disableIdleLockSwitch())
							}
						}
					})
			)
	}

	// Resumen de los horarios del alumno en un curso: aparece al pasar el mouse
	// sobre la etiqueta del curso (Esteban, 2026-09-11).
	const detalleCurso = (curso: any) => <Popover id={"curso_" + curso.nombre} style={{ maxWidth: "430px" }}>
		<Popover.Header as="h3" style={{ fontSize: "13px", padding: "8px 12px" }}>
			{curso.nombre}
			<span className={"badge rounded-pill " + pildoraDeCurso(curso)}
				style={{ marginLeft: "8px", fontSize: "12px" }}
			>
				{estadoDeCurso(curso)}
			</span>
		</Popover.Header>
		<Popover.Body style={{ fontSize: "12px", padding: "10px 12px" }}>
			{curso.matriculas.map((m: any, i: number) => {
				const ultimo = i + 1 === curso.matriculas.length
				return <div key={"m_" + i} style={{
					paddingBottom: ultimo ? "0px" : "8px",
					marginBottom: ultimo ? "0px" : "8px",
					borderBottom: ultimo ? "none" : "1px solid var(--wa-acento-suave)"
				}}>
					<div style={{ fontWeight: 600 }}>{m.curso}</div>
					{isEmpty(m.horario) ? "" : <div>{m.horario}</div>}
					{
						isEmpty(m.periodo) && isEmpty(m.maestro) ? "" :
							<div style={{ color: "var(--wa-apagado)" }}>
								{[m.periodo, m.maestro].filter((t: string) => !isEmpty(t)).join("  ·  ")}
							</div>
					}
					<div style={{ marginTop: "4px" }}>
						<span className={"badge rounded-pill " + (m.activa ? "bg-success" : "bg-secondary")}
							style={{ fontSize: "12px" }}
						>
							{m.estatus}
						</span>
						{isEmpty(m.inscrito) ? "" : <span style={{ color: "var(--wa-tenue)", marginLeft: "8px" }}>
							Inscrito el {m.inscrito}
						</span>}
					</div>
				</div>
			})}
		</Popover.Body>
	</Popover>


	return !sectionLoaded || pagination == null ? <></> : <>
		<SectionContainer
			searchFn={search}
			allowed={allowance}
			pagination={pagination}
			//Sin "Acciones / Eliminar seleccionados": se borra perfil por perfil desde los tres puntitos (2026-09-24).
			clearSearchFn={clearSearch}
			customSearch={customSearch}
			defaultSearch={defaultSearch}
			searchFormRef={searchFormRef}
			selectedRecords={selectedRecords}
			searchChangeFn={handleSearchChange}
			extendedFilterShown={extendedFilterShown}
			searchIcon={<CustomIcon name="student" />}
			clearSearchRequested={clearSearchRequested}
			//Sin botón "Agregar": los alumnos nuevos entran solo por solicitud de matrícula (Esteban, 2026-09-24).
			setExtendedFilterShown={setExtendedFilterShown}
			generalPlaceHolder={"Nombre, teléfono, observaciones, etc."}
			/*
				Los filtros viejos (Estatus, Horario Activo, saldos, intereses) se quitaron: todos los alumnos
				van en Activo y los únicos filtros son Curso / Periodo / Horario (Esteban, 2026-09-24).
			*/
			barraFiltros={
				<FiltroHorarios campusId={campusRef[currentUserCampus].id} onCambio={cambiarFiltroHorario}
					seleccion={{ courseNames: customSearch.courseNames || [], courseIds: customSearch.courseIds || [], periodIds: customSearch.periodIds || [], scheduleIds: customSearch.scheduleIds || [] }} />
			}>
			{
				(data.length < 1 && readOnlyData.length < 1) ?
					<>
						<hr />
						<div style={{ padding: "25px" }}>
							{Constants.noCampusSearchResults}
						</div>
						<hr />
					</>
					:
					esTelefono ?
					/*
						En telefono la tabla de quince columnas se cambia por tarjetas, con
						lo que de verdad se busca aqui: quien es, como localizarlo, que
						cursa y cuanto debe. (Esteban, 2026-09-16)
					*/
					<ListaTarjetas
						vacio="No hay alumnos que coincidan."
						/*
							La tabla pinta dos listas: los que el usuario no puede editar
							(readOnlyData) y los normales (data). Aqui solo se estaba
							usando la primera, asi que en cuentas donde todos son
							editables salia "No hay alumnos que coincidan" con paginas
							de sobra. (Esteban, 2026-09-16)
						*/
						/*
							OJO: en la lista editable cada elemento viene envuelto
							({selected, data}), no plano como en la de solo lectura. Sin
							desenvolverlo, record.status_id era undefined y la pantalla
							entera reventaba. (Esteban, 2026-09-16)
						*/
						/*
							Se conserva de que lista vino cada registro: las de solo
							lectura no deben abrir editables en el telefono si no lo
							hacen en la computadora. (Esteban, 2026-09-16)
						*/
						tarjetas={readOnlyData
							.map((record: any) => ({record, soloLectura: true}))
							.concat(data.map((fila: any) => ({record: fila?.data ?? fila, soloLectura: false})))
							.map(({record, soloLectura}: any) => ({
							clave: record.refIndex,
							titulo: nombrePropio([record.first_name, record.last_name].filter(Boolean).join(" ")) || "-",
							subtitulo: [record.phone1, record.phone2]
								.filter((phone: string) => isNotEmpty(phone))
								.map((phone: string) => formatPhoneDisplay(phone, prefijoDelPlantel))
								.join(" · "),
							marca: +record.expiredMonthlyBalance > 0
								? { texto: "Debe", tono: "ambar" }
								: undefined,
							campos: [
								{ etiqueta: "Correlativo", valor: record.student.identity_code },
								{ etiqueta: "Vencido", valor: sprintf("%.02f", +record.expiredMonthlyBalance) },
								{ etiqueta: "Saldo mensualidades", valor: sprintf("%.02f", +record.monthlyBalance) },
								{ etiqueta: "Saldo productos", valor: sprintf("%.02f", +record.productsBalance) },
								{ etiqueta: "Saldo servicios", valor: sprintf("%.02f", +record.servicesBalance) },
								{ etiqueta: "Créditos", valor: sprintf("%.02f", +record.positiveBalance) },
								{
									etiqueta: "Cursos",
									ancho: true,
									// cursos es una lista de objetos {nombre, activo}, no de textos.
									valor: isEmpty(record.cursos) ? "-" : <span className="waLtPildoras">{
										record.cursos.map((curso: any, i: number) =>
											<span key={"c_" + i} className={"waLtPildora" + (curso.activo ? " activa" : (curso.graduado ? " graduada" : ""))}>
												{curso.nombre}
											</span>)
									}</span>
								}
							],
							acciones: [
								{ texto: "Ver", principal: true, disabled: idleLocked, onClick: () => abrirPerfil(record, soloLectura) },
								...(puedeMatricular ? [{ texto: "Matricular", disabled: idleLocked || soloLectura, onClick: () => setEnrollingStudent(record) }] : []),
								{ texto: "Finanzas", disabled: idleLocked, onClick: () => navigateTo(record) }
							],
							menu: [
								{ texto: "Copiar enlace del perfil", onClick: () => copiarEnlace(record) },
								...(!puedeAgregarPlantel ? [] : [{ texto: "Agregar a otro plantel", onClick: () => showUpdateCampusModal(record) }]),
								...(!esSuperAdmin || soloLectura || !sePuedeBorrar(record) ? [] : [{ texto: "Eliminar alumno", onClick: () => confirmRemoval(record.id) }])
							]
						}))}
					/>
					:
					<table className="commonTable tablaAlumnos">
						<thead>
							<tr>
								{/*
									"Saldo mensualidades" va justo encima de Vencido y Total.

									Antes de Vencido hay CUATRO columnas (Correlativo, Nombre, Telefonos,
									Cursos), mas la de seleccion cuando el usuario puede borrar. El hueco
									decia siete y seis: dos de mas, y por eso el titulo aparecia encima de
									"Saldo productos" y "Saldo servicios". Detras de Total quedan cinco
									(productos, servicios, creditos y las dos de botones).
									(Esteban, 2026-09-21)
								*/}
								<th style={{ borderBottom: "unset" }} colSpan={4} />
								<th style={{ borderBottom: "unset", textAlign: "center", whiteSpace: "nowrap" }} colSpan={2}>
									Saldo mensualidades
								</th>
								<th style={{ borderBottom: "unset" }} colSpan={5} />
							</tr>
							<tr>
								<th ref={el => { if (el) { el.style.setProperty("border-bottom", "1px solid var(--wa-negro)", "important") } }}
									style={{ width: "1px", verticalAlign: "top" }}
								>
									Correlativo
								</th>
								{/*
									Sin restriccion de ancho, en una tabla de layout automatico esta
									columna se quedaba con TODO el espacio sobrante: medía unos 410px
									para nombres que como mucho piden 220. Con width 1px y sin partir
									palabras, se ajusta a su contenido igual que Correlativo, y el
									sobrante se lo reparten las demas. (Esteban, 2026-09-16)
								*/}
								<th style={{ verticalAlign: "top", width: "1px", whiteSpace: "nowrap" }}>
									Nombre
								</th>
								<th style={{ verticalAlign: "top" }}>
									Teléfonos
								</th>
								<th style={{ verticalAlign: "top" }}>
									Cursos
								</th>
								{/* Los títulos de las columnas de dinero van a la derecha, que es donde caen los
								    montos; alineados a la izquierda se veían desfasados (Esteban, 2026-09-11). */}
								<th style={{ verticalAlign: "top", textAlign: "right" }}>
									Vencido
								</th>
								<th style={{ verticalAlign: "top", textAlign: "right" }}>
									Total
								</th>
								<th style={{ verticalAlign: "top", textAlign: "right" }}>
									Saldo productos
								</th>
								<th style={{ verticalAlign: "top", textAlign: "right" }}>
									Saldo servicios
								</th>
								<th style={{ verticalAlign: "top", textAlign: "right" }}>
									Créditos
								</th>
								<th ref={el => {if(el)el.style.setProperty("border-bottom", "none", "important")}}/>
								<th />
							</tr>
						</thead>
						<tbody>
							{
								readOnlyData.map
									(
										(record: any, index: number) => <tr key={"user" + index}>
											<td ref={el => { if (el) { el.style.setProperty("border-bottom", "1px solid var(--wa-gris)", "important") } }}>
												{record.student.identity_code}
											</td>
											<td style={{ whiteSpace: "nowrap" }}>
												{nombrePropio([record.first_name, record.last_name].filter(Boolean).join(" ")) || "-"}
											</td>
											{/*
												Los dos telefonos en la misma linea obligaban a la columna a ser
												ancha por los pocos que tienen dos. Uno debajo del otro.
												(Esteban, 2026-09-16)
											*/}
											<td className="celdaTelefonos">
												{
													(() => {
														const numeros = [record.phone1, record.phone2]
															.filter((phone: string) => isNotEmpty(phone))
															.map((phone: string) => formatPhoneDisplay(phone, prefijoDelPlantel))

														return numeros.length < 1
															? "-"
															: numeros.map((numero: string, i: number) =>
																<div key={"tel_" + i}>{numero}</div>)
													})()
												}
											</td>
											<td className="celdaCursos">{
												isEmpty(record.cursos) ? "-" : record.cursos.map
													(
														(curso: any, index: number) => <OverlayTrigger key={"crc_" + index}
														  placement="auto" trigger={["hover", "focus"]} container={document.body}
														  overlay={detalleCurso(curso)}
														>
															<div className={"badge rounded-pill " + pildoraDeCurso(curso)}
															  style={{ cursor: "pointer" }}
															>
																{curso.nombre}
															</div>
														</OverlayTrigger>
													)
											}</td>
											<td style={{ whiteSpace: "nowrap", textAlign: "right", color: record.expiredMonthlyBalance == 0 ? "var(--wa-tinta)" : "var(--wa-rojo)" }}>
												{basicInfo.currencyRef["C_" + campusRef[currentUserCampus].company.currency_id].symbol}
												{sprintf("%.02f", +record.expiredMonthlyBalance)}
											</td>
											<td style={{ whiteSpace: "nowrap", textAlign: "right", color: record.monthlyBalance == 0 ? "var(--wa-tinta)" : "var(--wa-tinta)" }}>
												{basicInfo.currencyRef["C_" + campusRef[currentUserCampus].company.currency_id].symbol}
												{sprintf("%.02f", +record.monthlyBalance)}
											</td>
											<td style={{ whiteSpace: "nowrap", textAlign: "right", color: record.productsBalance == 0 ? "var(--wa-tinta)" : "var(--wa-oro)" }}>
												{basicInfo.currencyRef["C_" + campusRef[currentUserCampus].company.currency_id].symbol}
												{sprintf("%.02f", +record.productsBalance)}
											</td>
											<td style={{ whiteSpace: "nowrap", textAlign: "right", color: record.servicesBalance == 0 ? "var(--wa-tinta)" : "var(--wa-oro)" }}>
												{basicInfo.currencyRef["C_" + campusRef[currentUserCampus].company.currency_id].symbol}
												{sprintf("%.02f", +record.servicesBalance)}
											</td>
											<td style={{ whiteSpace: "nowrap", textAlign: "right", color: record.positiveBalance == 0 ? "var(--wa-tinta)" : "var(--wa-verde)" }}>
												{basicInfo.currencyRef["C_" + campusRef[currentUserCampus].company.currency_id].symbol}
												{sprintf("%.02f", +record.positiveBalance)}
											</td>
											<td ref={el => {if(el)el.style.setProperty("border-bottom", "none", "important")}}/>
											<td ref={el => {if(el)el.style.setProperty("border-bottom", "none", "important")}}/>
											<td ref={el => {if(el)el.style.setProperty("border-bottom", "none", "important")}}/>
											<td ref={el => {if(el)el.style.setProperty("border-bottom", "none", "important")}}/>
											<td>
												<OverlayTrigger overlay={<Tooltip id="tooltip-activos">Ver Detalle</Tooltip>} >
													<button
														type="button"
														style={ESTILO_ACCION}
														className="button btn btn-default"
														disabled={idleLocked}
														onClick={
															() => showPrompt({
																...record.data, phone: record.phone || "",
																specific_academic_degree: record.student.specific_academic_degree || "",
																id_clase_365: record.id_clase_365 || "",
																zipcode: record.zipcode || "",
																correlativo_clase_365: record.student.correlativo_clase_365 || "",
																current_occupation: record.student.current_occupation || "",
																academic_degree: record.student.academic_degree,
																academic_degree_id: record.student.academic_degree?.id,
																observations: record.student.observations || "",
																last_school_name: record.student.last_school_name || "",
																identity_code: record.student.identity_code,
																bool_read_only: 1
															})
														}>
														<span className="waVer">Ver</span>
													</button>
												</OverlayTrigger>
											</td>
										</tr>
									)
							}
							{
								data.map
									(
										(record: any) => <tr key={record.refIndex}>
											<td>
												{record.student.identity_code}
											</td>
											<td style={{ whiteSpace: "nowrap" }}>
												{nombrePropio([record.first_name, record.last_name].filter(Boolean).join(" ")) || "-"}
											</td>
											{/*
												Los dos telefonos en la misma linea obligaban a la columna a ser
												ancha por los pocos que tienen dos. Uno debajo del otro.
												(Esteban, 2026-09-16)
											*/}
											<td className="celdaTelefonos">
												{
													(() => {
														const numeros = [record.phone1, record.phone2]
															.filter((phone: string) => isNotEmpty(phone))
															.map((phone: string) => formatPhoneDisplay(phone, prefijoDelPlantel))

														return numeros.length < 1
															? "-"
															: numeros.map((numero: string, i: number) =>
																<div key={"tel_" + i}>{numero}</div>)
													})()
												}
											</td>
											<td className="celdaCursos">{
												isEmpty(record.cursos) ? "-" : record.cursos.map
													(
														(curso: any, index: number) => <OverlayTrigger key={"crc_" + index}
														  placement="auto" trigger={["hover", "focus"]} container={document.body}
														  overlay={detalleCurso(curso)}
														>
															<div className={"badge rounded-pill " + pildoraDeCurso(curso)}
															  style={{ cursor: "pointer" }}
															>
																{curso.nombre}
															</div>
														</OverlayTrigger>
													)
											}</td>
											<td style={{ whiteSpace: "nowrap", textAlign: "right", color: record.expiredMonthlyBalance == 0 ? "var(--wa-tinta)" : "var(--wa-rojo)" }}>
												{basicInfo.currencyRef["C_" + campusRef[currentUserCampus].company.currency_id].symbol}
												{sprintf("%.02f", +record.expiredMonthlyBalance)}
											</td>
											<td style={{ whiteSpace: "nowrap", textAlign: "right", color: record.monthlyBalance == 0 ? "var(--wa-tinta)" : "var(--wa-tinta)" }}>
												{basicInfo.currencyRef["C_" + campusRef[currentUserCampus].company.currency_id].symbol}
												{sprintf("%.02f", +record.monthlyBalance)}
											</td>
											<td style={{ whiteSpace: "nowrap", textAlign: "right", color: record.productsBalance == 0 ? "var(--wa-tinta)" : "var(--wa-oro)" }}>
												{basicInfo.currencyRef["C_" + campusRef[currentUserCampus].company.currency_id].symbol}
												{sprintf("%.02f", +record.productsBalance)}
											</td>
											<td style={{ whiteSpace: "nowrap", textAlign: "right", color: record.servicesBalance == 0 ? "var(--wa-tinta)" : "var(--wa-oro)" }}>
												{basicInfo.currencyRef["C_" + campusRef[currentUserCampus].company.currency_id].symbol}
												{sprintf("%.02f", +record.servicesBalance)}
											</td>
											<td style={{ whiteSpace: "nowrap", textAlign: "right", color: record.positiveBalance == 0 ? "var(--wa-tinta)" : "var(--wa-verde)" }}>
												{basicInfo.currencyRef["C_" + campusRef[currentUserCampus].company.currency_id].symbol}
												{sprintf("%.02f", +record.positiveBalance)}
											</td>
											{/*
												Una sola accion con palabra y el resto detras de "...", igual que
												en Personal. Antes eran cuatro iconos seguidos y habia que pasar el
												cursor por cada uno. (Esteban, 2026-09-16)
											*/}
											<td className="celdaAcciones"><div className="waAcciones">
												<button
													type="button"
													className="waAccionFila principal"
													disabled={idleLocked}
													onClick={() => abrirPerfil(record)}
												>
													Ver
												</button>
												{puedeMatricular ? <button
													type="button"
													className="waAccionFila"
													disabled={idleLocked}
													onClick={() => setEnrollingStudent(record)}
												>
													Matricular
												</button> : ""}
												<button
													type="button"
													className="waAccionFila"
													disabled={idleLocked}
													onClick={() => navigateTo(record)}
												>
													Finanzas
												</button>
												<OverlayTrigger
													trigger="click"
													rootClose
													placement="bottom-end"
													container={document.body}
													show={menuAbierto === record.id}
													onToggle={(abierto: boolean) => setMenuAbierto(abierto ? record.id : null)}
													overlay={
														<Popover id={"otrasAcciones_" + record.id} style={{ zIndex: 3000, maxWidth: "none" }}>
															<Popover.Body style={{ padding: "6px 0px" }}>
																<div style={{ padding: "2px 16px 8px", color: "var(--wa-apagado)", fontSize: "12px", whiteSpace: "nowrap" }}>
																	Otras acciones
																</div>
																<button type="button" className="dropdown-item"
																  style={{ fontSize: "13px", whiteSpace: "nowrap", display: "flex", alignItems: "center", gap: "10px", padding: "6px 16px" }}
																  onClick={() => { setMenuAbierto(null); copiarEnlace(record) }}
																>
																	<FontAwesomeIcon icon={solid("link")} style={{ width: "16px", flex: "0 0 auto" }} />
																	Copiar enlace del perfil
																</button>
																{/* Solo quien puede crear empleados / editar alumnos (Esteban, 2026-09-24): antes salían a cualquiera. */}
																{
																	(record.employee || !employeeAllowance.create) ? "" : <button type="button" className="dropdown-item"
																	  style={{ fontSize: "13px", whiteSpace: "nowrap", display: "flex", alignItems: "center", gap: "10px", padding: "6px 16px" }}
																	  onClick={
																		() => {
																			setMenuAbierto(null)
																			setSelectedEmployee
																			({
																				...record, id : null,
																				linkedUserId  : record.id,
																				imagePreview  : record.image,
																				phone1        : record.phone1 || "",
																				phone2        : record.phone2 || "",
																				zipcode       : record.zipcode || "",
																				observations  : "",
																				roles         : [],
																				enrollments   : [],
																				status_id     : employeeStatus.ACTIVE
																			})
																		}
																	  }
																	>
																		<CustomIcon name="addEmployee" style={{ width: "16px", height: "16px", flex: "0 0 auto" }} />
																		Enlistar como empleado
																	</button>
																}
																{!puedeAgregarPlantel ? "" : <button type="button" className="dropdown-item"
																  style={{ fontSize: "13px", whiteSpace: "nowrap", display: "flex", alignItems: "center", gap: "10px", padding: "6px 16px" }}
																  onClick={() => { setMenuAbierto(null); showUpdateCampusModal(record) }}
																>
																	<FontAwesomeIcon icon={solid("school")} flip="horizontal" style={{ width: "16px", flex: "0 0 auto" }} />
																	Agregar a otro plantel
																</button>}
																{/*
																	Eliminar: solo Superadmin, alumno por alumno y solo si no tiene saldo, pagos
																	ni historial (Esteban, 2026-09-24: sin borrado en masa).
																*/}
																{!esSuperAdmin || !sePuedeBorrar(record) ? "" : <button type="button" className="dropdown-item peligro"
																  style={{ fontSize: "13px", whiteSpace: "nowrap", display: "flex", alignItems: "center", gap: "10px", padding: "6px 16px" }}
																  onClick={() => { setMenuAbierto(null); confirmRemoval(record.id) }}
																>
																	<FontAwesomeIcon icon={solid("trash")} style={{ width: "16px", flex: "0 0 auto" }} />
																	Eliminar alumno
																</button>}
															</Popover.Body>
														</Popover>
													}
												>
													<button
														type="button"
														title="Otras acciones"
														disabled={idleLocked}
														className="waMenuBoton">
														<FontAwesomeIcon icon={solid("ellipsis")} />
													</button>
												</OverlayTrigger>
											</div></td>
											{/* Borrar ya no va suelto en la fila: está en los tres puntitos, solo para Superadmin (2026-09-24). */}
											<td />
										</tr>
									)
							}
						</tbody>
					</table>
			}
		</SectionContainer>
		{
			selectedStudent == null ? "" :
				<StudentInfoModal
					selectedStudent={selectedStudent}
					allowedUpdate={allowance.update}
					academicDegrees={academicDegrees}
					closeFn={(alumno?: any) => { setSelectedStudent(alumno ?? null); if (alumno == null) { limpiarEnlace() } }}
					afterCloseFn={search}
					date={currentDate}
				/>
		}
		{
			selectedEmployee == null ? "" : <EmployeeInfoModal
			  closeFn={setSelectedEmployee}
			  afterCloseFn={search}
			  academicDegrees={academicDegrees}
			  selectedEmployee={selectedEmployee}
			  allowedUpdate={allowance.update}
			  roles={employeeRoles}
			  date={currentDate}
			/>
		}
		{
			enrollingStudent == null ? "" : <EnrollStudentModal
			  studentId={enrollingStudent.id}
			  studentName={[enrollingStudent.first_name, enrollingStudent.last_name].filter(Boolean).join(" ")}
			  campusId={campusRef[currentUserCampus].id}
			  onClose={() => setEnrollingStudent(null)}
			  onEnrolled={() => { setEnrollingStudent(null); search() }}
			/>
		}
		<Suspense fallback={<div>Loading...</div>}>
			<ModalComponent
				title = {Constants.Common.updateCampus}
				showModal = {handleUpdateCampusModal}
				onClose = {closeUpdateCampusModal}
				onSave = {saveUpdateCampusModal}
				saveLock = {saveLock}>
					<UpdateCampusInfo
					saveLock = {{saveLock, setSaveLock}}
					currentStudentUpdate = {currentStudentUpdate}
					addNewCampusData = {{addNewCampusData, setAddNewCampusData}}
					>
					</UpdateCampusInfo>
			</ModalComponent>
		</Suspense>
	</>
}

export default Students
